// BarChartComponent.js
import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend } from 'chart.js';

// Register necessary chart components
ChartJS.register(BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend);

const BarChartComponent = ({ api }) => {
  const [chartData, setChartData] = useState({});
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch the data from the provided API
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}${api}`);
        const data = await response.json();
        
        // Filter for data from the last 7 days
        const last7DaysData = filterLast7DaysData(data);

        // Prepare the chart data with count and overallAverageRating
        const formattedData = prepareChartData(last7DaysData);

        setChartData(formattedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [api]);

  // Filter data for the last 7 days
  const filterLast7DaysData = (data) => {
    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 7); // Set the date to 7 days ago

    // Filter data for the last 7 days
    return data.filter(item => {
      const itemDate = new Date(item.date);
      return itemDate >= sevenDaysAgo && itemDate <= today;
    });
  };

  // Prepare chart data with count and overallAverageRating
  const prepareChartData = (data) => {
    const labels = data.map(item => item.date); // Dates for the X-axis
    const counts = data.map(item => item.count); // Count for the Y-axis (primary data)
    const averageRatings = data.map(item => item.overallAverageRating); // Overall average ratings

    return {
      labels: labels,
      datasets: [
        {
          label: 'Count Over Time',
          data: counts,
          backgroundColor: '#36A2EB', // Color for the count bars
          borderColor: '#36A2EB',
          borderWidth: 1,
          barThickness: 20,
        },
        {
          label: 'Average Rating Over Time',
          data: averageRatings,
          backgroundColor: '#FF6384', // Color for the average rating bars
          borderColor: '#FF6384',
          borderWidth: 1,
          barThickness: 20,
        },
      ],
    };
  };

  return (
    <div>
      <h2 className="text-xl font-semibold">Feedback for Last 7 Days</h2>
      {chartData.labels ? (
        <Bar
          data={chartData}
          options={{
            responsive: true,
            scales: {
              y: {
                beginAtZero: true,
                ticks: {
                  stepSize: 1, // Controls the spacing between the Y-axis ticks
                },
              },
            },
            plugins: {
              legend: {
                position: 'top', // Position the legend at the top
              },
            },
          }}
        />
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
};

export default BarChartComponent;
